var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'item-row-alignment',
         'button-with-image',
          !_vm.disabled && 'item-cursor',
          _vm.disabled && 'item-cursor-not-allowed'
    ],style:(_vm.btnLayoutStyle),on:{"click":_vm.onButtonClicked}},[_c('weex-text',{style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.text))]),(_vm.imageSrc)?_c('weex-image',{staticClass:"item-align-right",style:(_vm.imageStyle),attrs:{"src":_vm.imageSrc}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }